<script>
import Layout from "@/router/layouts/descontos";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Dropdown from 'primevue/dropdown';

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Dropdown,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      states: [
        { code: "AC", name: "Acre", },
        { code: "AL", name: "Alagoas", },
        { code: "AP", name: "Amapá", },
        { code: "AM", name: "Amazonas", },
        { code: "BA", name: "Bahia", },
        { code: "CE", name: "Ceará", },
        { code: "DF", name: "Distrito Federal", },
        { code: "ES", name: "Espírito Santo", },
        { code: "GO", name: "Goiás", },
        { code: "MA", name: "Maranhão", },
        { code: "MT", name: "Mato Grosso", },
        { code: "MS", name: "Mato Grosso do Sul", },
        { code: "MG", name: "Minas Gerais", },
        { code: "PA", name: "Pará", },
        { code: "PB", name: "Paraíba", },
        { code: "PR", name: "Paraná", },
        { code: "PE", name: "Pernambuco", },
        { code: "PI", name: "Piauí", },
        { code: "RJ", name: "Rio de Janeiro", },
        { code: "RN", name: "Rio Grande do Norte", },
        { code: "RS", name: "Rio Grande do Sul", },
        { code: "RO", name: "Rondônia", },
        { code: "RR", name: "Roraima", },
        { code: "SC", name: "Santa Catarina", },
        { code: "SP", name: "São Paulo", },
        { code: "SE", name: "Sergipe", },
        { code: "TO", name: "Tocantins", },
      ],
      cities: [],

      descontos: {
        status: null,
        region: {
          state: null,
          city: null,
        },
      },

      region: {
        loading: false,

        state: null,
        city: null,
      },

      change: {
        modal: false,
        loading: false,
      },

      partner: null,

      use: {
        modal: false,
        loading: false,
        offer: null,
        page: 1,
      },
    };
  },
  methods: {
    getDescontos() {
      this.loading = true;

      api
        .get('descontos')
        .then((response) => {
          if (response.data.status == 'success') {
            this.descontos.status = response.data.status;
            this.descontos.region = response.data.region;
          }
        })
    },
    getCities() {
      this.region.loading = true;

      if (this.region.state && this.region.state.code) {
        api
          .post('descontos/cidades', {
            state: this.region.state.code
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.cities = response.data.list
            }
          })
          .finally(() => {
            this.region.loading = false;
          })
      }
    },
    changeRegion() {
      this.change.modal = false;
      this.change.modal = true;
      this.region.state = this.descontos.region.state;
      this.region.city = this.descontos.region.city;
      this.getCities();
    },
    saveRegion() {
      if (this.region.state && this.region.city) {
        this.change.loading = true;

        api
          .post('descontos/regiao', {
            state: this.region.state.code,
            city: this.region.city.code
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.getDescontos();
              this.descontos.region = this.region;
              this.change.modal = false;
              this.change.loading = false;
            } else {
              this.$toast.error(response.data.message);
              this.change.loading = false;
            }
          })

      }
    },
    getPartner() {
      this.partner = null;

      api
        .get('descontos/parceiros/' + this.$route.params.id)
        .then((response) => {
          if (response.data.status == 'success') {
            this.partner = response.data.partner;
          } else {
            this.$router.push('/descontos');
          }
        })
        .catch(error => {
          if (error) {
            this.$router.push('/descontos');
          }
        })
    },
    showOffer(row) {
      this.use.modal = false;
      this.use.modal = true;
      this.use.offer = row;
      this.use.page = 1;
    },
    useOffer() {
      this.use.page = 2;
    },
    closeOffer() {
      this.use.modal = false;
      this.use.offer = null;
    }
  },
  mounted() {
    this.getDescontos();
    this.getPartner();
  },
  watch: {
    "region.state": function (v) {
      if (v != this.descontos.region.state) {
        this.cities = [];
        this.region.city = null;
        this.getCities();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between">
      <div>
        <h3>Descontos</h3>
        <p>Seu clube de descontos.</p>
      </div>
      <div v-if="!descontos.region.state && !descontos.region.city" class="p-3">
        <b-spinner variant="default" role="status" small></b-spinner>
      </div>
      <div v-else-if="descontos.region.state && descontos.region.city" class="text-right pt-2">
        <template v-if="descontos.region.state.code && descontos.region.city.name">
          {{ descontos.region.city.name }}/{{ descontos.region.state.code }}<br>
          <button class="btn btn-outline-default px-2 py-0 rounded-sm" v-on:click="changeRegion()">Alterar</button>
        </template>
        <template v-else>
          Escolha sua região<br>
          <button class="btn btn-outline-default px-2 py-0 rounded-sm" v-on:click="changeRegion()">Alterar</button>
        </template>
      </div>
    </div>

    <b-modal v-model="change.modal" modal-class="modal-right" hide-header hide-footer>
      <h5 class="mb-3">Selecione sua região</h5>
      <Dropdown class="w-100" v-model="region.state" dataKey="code" :options="states" :filter="true" optionLabel="name" placeholder="Selecione o seu estado">
        <template #value="slotProps">
          <div class="p-dropdown-car-value" v-if="slotProps.value.code">
            <span><strong>{{ slotProps.value.code }}</strong> – {{ slotProps.value.name }}</span>
          </div>
          <div v-else>
            <span><strong>{{ slotProps.placeholder }}</strong></span>
          </div>
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span><strong>{{ slotProps.option.code }}</strong> – {{ slotProps.option.name }}</span>
          </div>
        </template>
      </Dropdown>
      <Dropdown v-if="region.state && region.state.code" class="w-100 mt-2" v-model="region.city" dataKey="code" :options="cities" :filter="true" optionLabel="name" placeholder="Selecione sua cidade">
        <template #value="slotProps">
          <div class="p-dropdown-car-value" v-if="slotProps.value && slotProps.value.code">
            <span>{{ slotProps.value.name }}</span>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.name }}</span>
          </div>
        </template>
      </Dropdown>
      <div class="d-flex justify-content-between align-items-center mt-3">
        <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="this.change.loading" v-on:click="saveRegion();">
          Salvar
          <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </button>
        <a class="btn btn-outline-link" v-on:click="change.modal = false;">Fechar</a>
      </div>
    </b-modal>

    <div v-if="!partner" class="text-center mb-5">
      <b-spinner variant="default" role="status" small></b-spinner>
    </div>

    <div class="parceiro" v-if="partner">
      <div class="cover mb-3">
        <img :src="partner.cover">
      </div>
      <div class="info mb-5">
        <div class="logo">
          <img :src="partner.logo">
        </div>
        <div class="description">
          <h4>{{ partner.name }}</h4>
          <div class="d-block bg-default rounded p-1 px-3 font-size-12 text-white text-uppercase text-center">{{ partner.offer }}</div>
        </div>
      </div>
      <div class="offers mb-5">
        <div class="item" v-for="(row, index) in partner.offers" :key="index">
          <div class="card mb-0">
            <div class="card-body p-2">
              <div class="cover mb-3">
                <img :src="row.cover">
              </div>
              <h5 class="text-center mb-3">{{ row.title }}</h5>
              <p class="text-center">{{ row.discount }}</p>
              <button class="btn btn-default btn-block" v-on:click="showOffer(row)">Utilizar Benefício</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5>Sobre à {{ partner.name }}</h5>
          <div v-html="partner.about"></div>
        </div>
      </div>
    </div>

    <b-modal v-if="partner" v-model="use.modal" modal-class="modal-center" centered hide-header hide-footer>
      <template v-if="use.page == 1">
        <div class="use">
          <div class="logo">
            <img :src="partner.logo">
          </div>
          <div>
            <h5>{{ partner.name }}</h5>
            <div class="d-block bg-default rounded p-1 px-3 font-size-12 text-white text-uppercase text-center">{{ partner.offer }}</div>
          </div>
        </div>
        <div v-if="use.offer" class="offer">
          <div v-html="use.offer.rules" class="mb-4"></div>
          <button class="btn btn-block btn-default btn-lg" v-on:click="useOffer()">Utilizar Benefício</button>
          <button class="btn btn-block btn-outline-default btn-lg" v-on:click="closeOffer()">Cancelar</button>
        </div>
      </template>
      <template v-else-if="use.page == 2">
        <div v-if="use.offer && use.offer.action" class="text-center">
          <div v-if="use.offer.action == 'to_redirect'" class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" style="fill: green;">
              <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
            </svg>
            <h4>Benefício disponível</h4>
            <h5>Seu benefício já está disponível e pronto para ser utilizado</h5>
            <p>Clique para ser redirecionado para a página do parceiro onde poderá fazer o uso do seu benefício</p>
            <a class="btn btn-default btn-block btn-lg d-flex flex-gap-5 justify-content-center align-items-center" :href="use.offer.url" target="_blank">
              <div>Acessar parceiro</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
          <div v-else-if="use.offer.action == 'buy_online'" class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" style="fill: green;">
              <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
            </svg>
            <h4>Benefício disponível</h4>
            <h5>Seu benefício já está disponível e pronto para ser utilizado</h5>
            <p>Clique para ser redirecionado para a página do parceiro onde poderá fazer o uso do seu benefício</p>
            <button class="btn btn-outline-default btn-block btn-lg text-uppercase d-flex flex-gap-5 justify-content-center align-items-center" v-clipboard:copy="referral
              " v-on:click="$noty.success('O cupom foi copiado!')">
              <div>CUPOM: {{ use.offer.code }}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path
                  d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
                </path>
              </svg>
            </button>
            <a class="btn btn-default btn-block btn-lg text-uppercase d-flex flex-gap-5 justify-content-center align-items-center" :href="use.offer.url" target="_blank">
              <div>Acessar parceiro</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
              </svg>
            </a>
          </div>
          <div v-else-if="use.offer.action == 'buy_offline'" class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" style="fill: green;">
              <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
            </svg>
            <h4>Benefício disponível</h4>
            <h5>Seu benefício já está disponível e pronto para ser utilizado</h5>
            <p>Dirija-se ao estabelecimento parceiro e se identifique com seu CPF para validação</p>
          </div>

          <button class="btn btn-block btn-outline-default btn-lg" v-on:click="closeOffer()">Fechar</button>
        </div>
      </template>
    </b-modal>
  </Layout>
</template>

<style scoped>
.use {
  display: flex;
  align-items: center;
  gap: 20px;
  border-bottom: solid 2px #D1D1E3;
  margin-bottom: 15px;
  padding: 1.25rem;
}
.use .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px #e5e5e5;
  border-radius: 100%;
  overflow: hidden;
  width: 80px;
  height: 80px;
}

.use .logo img {
  object-fit: cover;
  width: 80px;
  height: 80px;
}</style>